export default {
  SET_SIDEBAR: (state, payload) => {
    state.sidebarItems = payload
  },
  SET_TOKEN: (state, payload) => {
    state.token = payload
  },
  REMOVE_TOKEN: (state, payload) => {
    state.token = ''
  },
  SET_USER_DETAILS: (state, payload) => {
    state.userDetails = payload
  },
  REMOVE_USER_DETAILS: (state, payload) => {
    state.userDetails = {}
  },
  RESET_STORE: (state, payload) => {
    state.token = '',
    state.userInfo = null,
    state.isLoggedIn = false,
    state.userDetails = {}
  }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js